import InstallatiesBlock from "../components/blocks/InstallatiesBlock";

const InstallatiesOverview = () =>
{

    return (<>
        <InstallatiesBlock/>
    </>)
}
export default InstallatiesOverview